import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import FormField from "../Helpers/FormField";
import {checkbox, custom} from "../../utils/linker";
import {ComponentContext} from "../../contexts";
import Bool from "./CustomFields/Bool";
import Resize from "./CustomFields/Resize";
import Select from "./CustomFields/Select";
import String from "./CustomFields/String";
import Int from "./CustomFields/Int";

function FieldSettings(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const getField=()=>{
    if(props.linker.value.type_code) {
      return compContext.field_types.data[props.linker.value.type_code];
    }
    return null;
  };

  const fieldsMap={
    int: Int,
    bool: Bool,
    resize: Resize,
    select: Select,
    string: String
  }

  const renderAddFields=()=>{
    const arr=[];
    for(let code in getField().options) {
      const opt=getField().options[code];
      const Comp=fieldsMap[opt.type];
      if(typeof Comp !== "undefined") {
        arr.push(<Comp key={code} code={code} field={getField()} option={opt} {...custom(props.linker.value, code)} />);
      } else {
        arr.push(
          <FormField key={code} title={opt.name}>
            Неизвестный тип поля: {opt.type}
          </FormField>
        );
      }
    }
    return arr;
  };

  if(!getField()) {
    return null;
  }


  return (
    <div>
      {renderAddFields()}
    </div>
  )
};

FieldSettings.defaultProps = {};

FieldSettings.propTypes = {}

export default observer(FieldSettings);
